<div class="fs-mt-3" *ngIf="shouldShowExternalManagementMessage">
  <p>
    This "READ ONLY" group cannot be changed in Fusus. To manage user and role access, update the
    "{{ permissionNameInEcom }}" permissions in
    <a target="_blank" [href]="ecomAdminLink">Evidence.com</a>.
  </p>
  <p>
    <b>Note:</b> Updates will only appear here after changes are made in Evidence.com and the user
    has logged into Fusus.
  </p>
</div>

<div class="fs-mt-3" *ngIf="shouldShowPermissionExternalManagementMessage">
  <p>
    This group's permissions are "READ ONLY" and cannot be changed in Fusus. To manage the Group's
    name and permissions, update the corresponding group in
    <a target="_blank" [href]="ecomGroupLink">Evidence.com</a>.
  </p>
  <p>
    <b>Note:</b> Updates will appear here after changes are made in Evidence.com and have been
    synced to Fusus.
  </p>
</div>

<div class="fs-mt-3" *ngIf="shouldShowMemberExternalManagementMessage">
  <p>
    This group's members are "READ ONLY" and cannot be changed in Fusus. To manage the Group's name
    and members, update the corresponding group in
    <a target="_blank" [href]="ecomGroupLink">Evidence.com</a>.
  </p>
  <p>
    <b>Note:</b> Updates will appear here after changes are made in Evidence.com and have been
    synced to Fusus.
  </p>
</div>
